module.exports = __webpack_public_path__ + "static/media/gbtb_1.b66b9647.jpg";